export default __webpack_public_path__ + "static/919_mexico_logo_en-ff5019a13595b04cdefbaa34b8a3ebd2.svg";